import { PALETTE, Crescent, MosqueSilhouette, SeatedFigure, Shadow, Star } from "./parts";

/**
 * Rahlede Kur'an okuyan, takkeli ve cübbeli yüzsüz bir figür. Kitap önden
 * görüldüğü için yalnız cildin süslü sırtı görünür, sayfalarda yazı yok.
 */
export default function QuranReader({ className = "" }) {
  const { cloud, mist, gold, orange, wood, woodDark, deep, paper } = PALETTE;
  return (
    <svg viewBox="0 0 320 300" className={className} role="img" aria-hidden="true" focusable="false">
      <circle cx={160} cy={152} r={132} fill={cloud} />
      <MosqueSilhouette x={160} y={236} w={200} color={mist} />
      <Crescent x={236} y={70} r={14} color={gold} bg={cloud} />
      <Star x={70} y={84} r={5} color={gold} opacity={0.8} />
      <Star x={228} y={112} r={3.5} color={gold} opacity={0.6} />
      <Star x={98} y={52} r={3} color={orange} opacity={0.5} />

      {/* seccade */}
      <Shadow cx={160} cy={268} rx={130} ry={14} opacity={0.1} />
      <path d="M44,262 Q160,244 276,262 Q160,282 44,262 Z" fill={gold} opacity={0.35} />
      <path d="M62,262 Q160,249 258,262 Q160,276 62,262 Z" fill="none" stroke={orange} strokeWidth={1.4} opacity={0.5} strokeDasharray="2 5" />

      <SeatedFigure x={160} y={262} scale={1.34} headwear="takke" arms="rest" />

      {/* rahle: çapraz iki tahta */}
      <Shadow cx={160} cy={266} rx={42} ry={5} opacity={0.18} />
      <path d="M190,266 L136,200" stroke={woodDark} strokeWidth={9} strokeLinecap="round" />
      <path d="M130,266 L184,200" stroke={wood} strokeWidth={9} strokeLinecap="round" />
      <circle cx={160} cy={233} r={3.2} fill={woodDark} />

      {/* açık Kur'an, sırtı bize dönük: sayfa kenarları ve süslü cilt */}
      <path d="M118,190 Q139,196 160,204 Q181,196 202,190 L200,186 Q180,191 160,199 Q140,191 120,186 Z" fill={paper} />
      <path d="M116,192 Q138,198 160,207 L160,232 Q138,222 120,218 Z" fill={deep} />
      <path d="M204,192 Q182,198 160,207 L160,232 Q182,222 200,218 Z" fill="#0B565B" />
      <path d="M122,197 Q139,202 155,209 L155,224 Q139,217 125,213 Z" fill="none" stroke={gold} strokeWidth={1.3} />
      <path d="M198,197 Q181,202 165,209 L165,224 Q181,217 195,213 Z" fill="none" stroke={gold} strokeWidth={1.3} />
      <circle cx={139.5} cy={210} r={3.6} fill="none" stroke={gold} strokeWidth={1.3} />
      <circle cx={180.5} cy={210} r={3.6} fill="none" stroke={gold} strokeWidth={1.3} />
    </svg>
  );
}
